import { View } from "binder"
import { FormBuilderElement } from "../../element";
import { DragableElementDecoratorViewModel } from "./dragableElementDecorator-viewModel";

export class CompactView extends View<DragableElementDecoratorViewModel>{
    GetViewUniqueId(): string {
        return "V-0D9609CA-1C65-47E2-9D4C-F1FC8246744C"
    }
    loadHtml(): string {
        let element = require('./compact.html').default;
        let style = require('./compact.less');
        return element;
    }
    constructor() {
       super();
    }
    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;
}
